import OnDemandReading from './onDemandReading';

export default OnDemandReading;
